module.exports = __webpack_public_path__ + "img/6.8f5423b9.png";